import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchData } from "../../helper/ApiCall";
import { END_POINT, METHODS, BASE_URL_IMAGE } from "../../helper/helper";
import "../dashscreen/BlogCss.css";
import Header from "./header";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);

  const loadBlog = async () => {
    try {
      const result = await fetchData(
        END_POINT.GetBlogById + id,
        METHODS.GET
      );
      if (result?.success) {
        setBlog(result.data);

        // Load related blogs
        const allBlogs = await fetchData(END_POINT.GetBlog, METHODS.GET);
        if (allBlogs?.success) {
          const filtered = allBlogs.data
            .filter((b) => b._id !== id)
            .slice(0, 3);
          setRelated(filtered);
        }
      }
    } catch (err) {
      console.error("Error loading blog:", err);
    }
  };

  useEffect(() => {
    loadBlog();
  }, [id]);

  if (!blog) return <p>Loading...</p>;

  // Share Function
  const handleShare = (platform) => {
    const url = window.location.href;
    const title = blog.title;

    let shareUrl;

    switch (platform) {
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          url
        )}&text=${encodeURIComponent(title)}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          url
        )}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          url
        )}`;
        break;
      case "link":
        navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
        return;
      default:
        return;
    }

    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  return (
    <>

      <Header />


      <article className="article-container">
        

        <a href="/blogs" className="back-link">← Back to Blog</a>


        <div className="article-header">
          <div className="article-category">
            {blog.category || "General"}
          </div>

          <h1 className="article-title">{blog.title}</h1>

          <div className="article-meta">
            <div className="author-section">
              <div className="author-avatar-large">
                {blog.author?.charAt(0)}
              </div>

              <div className="author-details">
                <div className="author-name-large">
                  {blog.author || "Admin"}
                </div>
                <div className="publish-date">
                  Published on {blog.createdAt?.slice(0, 10)}
                </div>
              </div>
            </div>

            <div className="meta-items">
              <span className="meta-item">
                ⏱️ {blog.readTime || "5 min read"}
              </span>
              <span className="meta-item">
                👁️ {blog.views || 0} views
              </span>
            </div>
          </div>
        </div>

        <div className="featured-image-container">
          <img
            src={`${BASE_URL_IMAGE}${blog.image}`}
            alt={blog.title}
          />
        </div>

        <div
          className="article-content"
          dangerouslySetInnerHTML={{ __html: blog.desc }}
        />

        {/* TAGS */}
        <div className="article-tags">
          <div className="tags-label">Tags:</div>
          <div className="tags-list">
            {blog.tags?.map((tag, i) => (
              <span key={i} className="tag">
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* SHARE */}
        <div className="share-section">
          <div className="share-label">Share this article</div>
          <div className="share-buttons">
            <div
              className="share-btn twitter"
              onClick={() => handleShare("twitter")}
            >
              𝕏
            </div>

            <div
              className="share-btn linkedin"
              onClick={() => handleShare("linkedin")}
            >
              in
            </div>

            <div
              className="share-btn facebook"
              onClick={() => handleShare("facebook")}
            >
              f
            </div>

            <div
              className="share-btn link"
              onClick={() => handleShare("link")}
            >
              🔗
            </div>
          </div>
        </div>

        {/* RELATED POSTS */}
        <div className="related-posts">
          <h2 className="related-title">Related Articles</h2>
          <div className="related-grid">
            {related.map((post) => (
              <div
                key={post._id}
                className="related-card"
                onClick={() => navigate(`/blog-detail/${post._id}`)}
              >
                <img
                  src={`${BASE_URL_IMAGE}${post.image}`}
                  alt={post.title}
                  className="related-image"
                />
                <div className="related-content">
                  <div className="related-category">
                    {post.category}
                  </div>
                  <h3 className="related-card-title">
                    {post.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </article>

      <footer>
        <div className="container">
          <div className="footer-content">
            <p>© 2026 AIHub. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default BlogDetail;